import gql from 'graphql-tag';

export const GET_COLLECTIONS_SUMMARY = gql`
  query GetCollectionsSummary {
    guarantor {
      encounters(collections: true, limit: 3, offset: 0) {
        id
        dischargeDate
        balance
        paymentPlan
        patient {
          id
          firstName
          lastName
        }
      }
      paidEncounters(limit: 3) {
        id
        dischargeDate
        balance
        paymentPlan
        patient {
          id
          firstName
          lastName
        }
      }
      payments(limit: 3) {
        receiptNumber
        amount
        date
        description
      }
    }
  }
`;
